export default __webpack_public_path__ + "static/description-video-t-b6f9d054ab24a8078002da2bdd7d1e1e.png";